export enum ProductProviders {
	HYGEIA = 'hygeia',
	BASTION = 'bastion'
}

export enum ProductNames {
	COMPREHENSIVE = 'comprehensive cover',
	MINI_COMPREHENSIVE = 'mini comprehensive',
	THIRD_PARTY = 'third party',
	MONTHLY_COMPREHENSIVE = 'monthly comprehensive',
	FLEXICARE = 'flexicare',
	FLEXICARE_MINI = 'flexicare mini',
	ZENCARE = 'zencare',
	ZENCARE_PLUS = 'zencare plus',
	ZENCARE_PRIME = 'zencare prime',
	GADGET = 'gadget',
	LAPTOPCOVER = 'laptop cover',
	TRAVEL_ALLIANZ = 'travel cover',
	AIICO_TRAVEL = 'aiico travel cover',
	ZENCARE_SENIOR_CITIZEN = 'zencare senior citizen',
	ZENCARE_PLUS_SENIOR_CITIZEN = 'zencare plus senior',
	PRIMECARE = 'primecare',
	PRIMECARE_PLUS = 'primecare plus'
}

export enum ProductCodeNames {
	COMPREHENSIVE_AUTO = 2,
	MINI_COMPREHENSIVE = 4,
	THIRD_PARTY = 1,
	MONTHLY_COMPREHENSIVE = 14,

	GADGET = 5,
	LAPTOP_COVER = 30,

	TRAVEL_ALLIANZ = 29,
	TRAVEL_AIICO = 6,

	FLEXICARE_HYGEIA = 31,
	FLEXICARE_BASTION = 38,
	FLEXICARE_MINI_BASTION = 39,
	FLEXICARE_MINI_HYGEIA = 32,

	ZENCARE_HYGEIA = 17,
	ZENCARE_BASTION = 33,
	ZENCARE_PLUS = 16,
	ZENCARE_PRIME = 18,
	ZENCARE_PLUS_BASTION = 34,
	ZENCARE_PRIME_BASTION = 35,
	ZENCARE_SENIOR_CITIZEN = 22,
	ZENCARE_PLUS_SENIOR_CITIZEN = 24,

	PRIMECARE_HYGEIA = 28,
	PRIMECARE_BASTION = 36,
	PRIMECARE_PLUS_HYGEIA = 29,
	PRIMECARE_PLUS_BASTION = 37
}

export enum ProductCategory {
	Health = 'health',
	Auto = 'auto',
	Gadget = 'gadget',
	Travel = 'travel',
	Others = 'others'
}

export enum Categories {
	laptop = 'c2ff1258-c609-430a-be3e-24412309b144'
}
export enum ChannelSource {
	TWITTER = 'twitter',
	INSTAGRAM = 'instagram',
	GOOGLE = 'google',
	FACEBOOK = 'facebook',
	WEBSITE = 'website',
	BDM = 'bdm',
	SALES_TEAM = 'sales_team',
	SALESAGENT = 'sales_agent'
}
export enum HealthType {
	STANDARD = 'standard',
	FAMILY = 'family'
}
export enum UserTypes {
	BUSINESS = 'business',
	INDIVIDUAL = 'individual'
}
